import React from 'react';
import { useLocation } from 'react-router-dom';
import { LogoIsotype } from '@/components/Logo';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const location = useLocation();
  const errorMsg = location.state?.error;

  const handleLogin = () => {
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen brand-radial grid-bg flex items-center justify-center px-4">
      <div className="panel w-full max-w-md p-8 shadow-2xl" data-testid="login-panel">
        <div className="flex items-center gap-3 mb-6">
          <LogoIsotype size={44} />
          <div className="leading-tight">
            <div className="font-display font-semibold text-xl brand-gradient-text">TradIA</div>
            <div className="text-[11px] uppercase tracking-[0.14em] text-muted-foreground mt-0.5">Firma virtual multi-agente</div>
          </div>
        </div>

        <h2 className="font-display text-2xl mb-2" data-testid="login-heading">Bienvenido, Jorge</h2>
        <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
          Inicia sesión para revisar el briefing del día, auditar candidatas capa por capa y aprobar operaciones.
        </p>

        {errorMsg && (
          <div className="panel-soft border-destructive/40 text-sm p-3 mb-4" data-testid="login-error">
            {errorMsg}
          </div>
        )}

        <button
          data-testid="btn-login-google"
          onClick={handleLogin}
          className="w-full flex items-center justify-center gap-2 rounded-md px-4 py-2.5 border border-border hover:border-[hsl(var(--brand-accent))] hover:bg-muted transition-colors text-sm"
        >
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.8 32 29.3 35 24 35c-6.1 0-11-4.9-11-11s4.9-11 11-11c2.8 0 5.4 1 7.4 2.8l5.7-5.7C33.7 6.6 29.1 4.7 24 4.7 13 4.7 4 13.6 4 24.7s9 20 20 20c11 0 20-9 20-20 0-1.3-.1-2.7-.4-4.2z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8c1.8-3.7 5.7-6.3 10.1-6.3 2.8 0 5.4 1 7.4 2.8l5.7-5.7C33.7 6.6 29.1 4.7 24 4.7 16.3 4.7 9.6 9.1 6.3 14.7z"/><path fill="#4CAF50" d="M24 44.7c5 0 9.6-1.9 13.1-5l-6-5.1c-2 1.5-4.4 2.4-7.1 2.4-5.3 0-9.8-3-11.3-7.1L6 34.4C9.2 40.4 16.1 44.7 24 44.7z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.2-4.3 5.6l6 5.1C40.2 34.7 44 30.1 44 24.7c0-1.3-.1-2.7-.4-4.2z"/></svg>
          Iniciar sesión con Google
        </button>
        <p className="text-[11px] text-muted-foreground mt-6 leading-relaxed">
          Este MVP opera con datos simulados. Ninguna orden se envía a un exchange real; toda decisión humana queda auditada capa por capa.
        </p>
      </div>
    </div>
  );
}
